import styles from './card.module.sass';
import spicaSvg from '@@/mixing/images/spica.svg';
import { ButtonPrimary } from '@/shared/ui/button';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import {
  $mixingParamsData,
  $myWarehouses,
  $warehousesForMixingDataResponse,
  fetchMixingParamsData,
  fetchMyWarehouses,
  fetchWarehousesForMixingDataFx,
} from '@/widgets/recipe/model';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'effector-react';
import {
  compareDateWithCurrentTime,
  getRemainingMinutes,
} from '@/modules/common/helpers/compare-date.helper';
import { cacheLastSearchResult } from '@/modules/common/helpers/cache-search-result.helper';
import { $selectedWarehousesForSearch } from '@/modules/search/store/search.store';
import { useEffect, useState } from 'react';
import { PURCHASE_PRICE_WITHOUT_VAT } from '@/shared/constants/price.constants';

fetchMyWarehouses();

export const Card = ({ title, data }: ICard) => {
  const navigate = useNavigate();
  const resultData: any = useStore($mixingParamsData);
  const warehouses: any = useStore($myWarehouses);
  const selectedWhs = useStore($selectedWarehousesForSearch);

  const [timeLeft, setTimeLeft] = useState(
    compareDateWithCurrentTime(String(data.expiration_date)),
  );

  useEffect(() => {
    if (data.expiration_date) {
      const overallTimeRemainder = getRemainingMinutes(String(data.expiration_date));
      setTimeLeft(compareDateWithCurrentTime(String(data.expiration_date)));
      const minutesRemainder = getRemainingMinutes(String(data.expiration_date));
      console.log(minutesRemainder);
      if (!minutesRemainder)
        return setTimeLeft(compareDateWithCurrentTime(String(data.expiration_date)));
      const intervalMs = minutesRemainder && minutesRemainder < 10 ? 1000 : 30000;
      const offerExpirationReload = setInterval(() => {
        setTimeLeft(compareDateWithCurrentTime(String(data.expiration_date)));
        //clearInterval(offerExpirationReload)
      }, intervalMs);
      return () => {
        clearInterval(offerExpirationReload);
      };
    }
  }, [data]);

  return (
    <div className={styles.card}>
      <div className={styles.top__content}>
        <div className={styles.icon}>
          <img src={spicaSvg} alt="spica" />
        </div>
        <span>{title}</span>
      </div>
      <div className={styles.mid__content}>
        <div className={styles.specs__first}>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>год урожая</span>
            <span>{data.year}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>клейковина</span>
            <span>≥ {data.gluten}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>ИДК</span>
            <span>≤ {data.idk}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>клоп</span>
            <span>≤ {data.clop} </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>протеин</span>
            <span>≥ {Number(data.protein).toFixed(2)}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>ЧП</span>
            <span>≥ {data.cp}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>натура</span>
            <span>≥ {data.nature} </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>влажность</span>
            <span>
              ≤ {data.humidity} <span className={styles.spec__item_sign}>%</span>
            </span>
          </div>
        </div>
        <div className={styles.specs__second}>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>сорная примесь</span>
            <span>
              ≤ {data.weed} <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>
              примесь других злаковых культур
            </span>
            <span>
              ≤ {data.admixture_other_cereals}{' '}
              <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>пшеница другого типа</span>
            <span>
              ≤ {data.wheat_different_type}{' '}
              <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
        </div>
      </div>
      <div className={styles.bottom__content}>
        <div className={styles.bottom__price}>
          <span className={styles.spec__item_label}>срок действия предложения</span>
          <span className={styles.deadline}>
            {data.expiration_date
              ? compareDateWithCurrentTime(String(data.expiration_date))
              : ''}
          </span>
        </div>
        <div className={styles.bottom__price}>
          <span className={styles.spec__item_label}>{PURCHASE_PRICE_WITHOUT_VAT}</span>
          <span className={styles.total__price}>
            {data.price && Number(data.price) > 0
              ? ` ${data.price.toLocaleString('RU-ru')} ₽/т`
              : 'по запросу'}
          </span>
        </div>
        <ButtonPrimary
          label="найти зерно на складе"
          className={styles.bottom__button}
          onClick={() => {
            const reqObj = {
              class: data.wheat_class,
              type: data.wheat_type,
              warehouse_id: selectedWhs
                ? selectedWhs
                    .filter((item) => item.checked)
                    ?.map((item: any) => item.id)
                    ?.toString()
                : [], //checkedWarehouses.map((item) => item.id),
              cp: +data.cp,
              nature: +data.nature,
              humidity: +data.humidity,
              protein: +data.protein,
              gluten: +data.gluten,
              idk: +data.idk,
              deviation: 5,
              temperature: 0,
            };
            const params = new URLSearchParams(reqObj as any).toString();
            //fetchMixingParamsData(reqObj);
            // if (resultData?.errors) {
            //   const errorArray = Object.entries(resultData?.errors)?.flatMap(
            //     ([key, value]) => value,
            //   );
            //   errorArray.map((item) =>
            //     notification.warning({
            //       message: String(item),
            //     }),
            //   );
            //   return;
            // }

            const selectedWarehouses = selectedWhs.filter((item) => item.checked);
            if (selectedWarehouses.length < 1) {
              return notification.warning({
                message:
                  'для поиска зерна, укажите склады, на которых необходимо произвести поиск',
              });
            }
            // используется для кеширования последнего результата поиска
            cacheLastSearchResult(`/mixing/manual?${params}`);

            navigate(`/mixing/manual?${params}`);
          }}
        />
      </div>
    </div>
  );
};

interface ICard {
  title: string;
  data: OfferDetails;
}
